import React from "react";
import { FieldInputProps, useField } from "formik";
import zxcvbn from "zxcvbn";

export type PasswordStrengthProps = {
  fieldName: string;
  onInfoClick(): void;
  hideDetails?: boolean;
};

export type PasswordStrengthDetails = {
  className: string;
  text: string;
};

const passwordStrengthDetails = (
  result: zxcvbn.ZXCVBNResult
): PasswordStrengthDetails => {
  switch (result.score) {
    case 1:
      return {
        className: "Strength_Weak",
        text: "Weak",
      };
    case 2:
      return {
        className: "Strength_SoSo",
        text: "So-so",
      };
    case 3:
      return {
        className: "Strength_Good",
        text: "Good",
      };
    case 4:
      return {
        className: "Strength_Great",
        text: "Great!",
      };
    default:
      return {
        className: "Strength_VeryWeak",
        text: "Very weak",
      };
  }
};

export const PasswordStrengthDetails: React.FC<{
  fieldName: string;
  onInfoClick: () => void;
}> = ({ fieldName, onInfoClick }) => {
  const [field] = useField(fieldName);
  const result = zxcvbn(field.value);

  return (
    <div
      className={`PasswordStrengthInfo ${
        passwordStrengthDetails(result).className
      }`}
    >
      {passwordStrengthDetails(result).text}
      <div className="MoreInfo" onClick={() => onInfoClick()}>
        i
      </div>
    </div>
  );
};

const PasswordStrengthMeter: React.FC<PasswordStrengthProps> = ({
  fieldName,
  onInfoClick,
  hideDetails,
}) => {
  const [field] = useField(fieldName);
  const result = zxcvbn(field.value);

  return (
    <div className="PasswordStrengthHelper">
      <div
        className={`PasswordStrengthMeterContainer ${
          passwordStrengthDetails(result).className
        }`}
      >
        <div className="PasswordStrengthMeter" />
        <div className="PasswordStrengthMeter" />
        <div className="PasswordStrengthMeter" />
        <div className="PasswordStrengthMeter" />
      </div>

      {!hideDetails && (
        <PasswordStrengthDetails
          fieldName={fieldName}
          onInfoClick={onInfoClick}
        />
      )}
    </div>
  );
};
export { PasswordStrengthMeter };
